import { addDays, format, isFuture } from "date-fns";
import { get, isEmpty } from "lodash";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Controls from "../../components/Controls";
import PointHubButton from "../../components/PointHubButton";
import { selectEventAggregate } from "../../modules/eventAggregate/selectors";
import trackingService, { Events } from "../../services/trackingService";
import { getDayRange } from "../../utils/date";

const formatDay = (eventAggregate) => {
  if (!eventAggregate || !eventAggregate.start_date) {
    return "";
  }

  return format(eventAggregate.start_date, "MMM D");
};

const DailyPointSlider = ({ activeDateRange, setActiveDateRange }) => {
  const [dateRange, setDateRange] = useState(getDayRange(new Date()));
  const eventAggregate = useSelector(
    selectEventAggregate({
      period: dateRange.period,
    })
  );

  const updateDateRange = (offset) => {
    const updatedDateRange = getDayRange(addDays(dateRange.startDate, offset));
    setDateRange(updatedDateRange);
    setActiveDateRange(updatedDateRange);
  };

  useEffect(() => {
    if (dateRange.period === activeDateRange.period) {
      setActiveDateRange(dateRange);
    }
  }, [dateRange]);

  return (
    <Controls
      disableNext={isFuture(dateRange.endDate)}
      onNavigateNext={() => {
        updateDateRange(1);
        trackingService.trackEvent(Events.POINTS_NEXT, {
          points_period: "day",
        });
      }}
      onNavigatePrevious={() => {
        updateDateRange(-1);
        trackingService.trackEvent(Events.POINTS_PREVIOUS, {
          points_period: "day",
        });
      }}
    >
      <PointHubButton
        active={
          !activeDateRange.period || dateRange.period === activeDateRange.period
        }
        date={formatDay(eventAggregate)}
        label="Day"
        loading={isEmpty(eventAggregate)}
        onClick={() => {
          setActiveDateRange(dateRange);
          trackingService.trackEvent(Events.POINTS_CLICK, {
            points_period: "day",
          });
        }}
        value={get(eventAggregate, "points")}
      />
    </Controls>
  );
};

DailyPointSlider.propTypes = {
  activeDateRange: PropTypes.shape({
    endDate: PropTypes.instanceOf(Date),
    period: PropTypes.string,
    startDate: PropTypes.instanceOf(Date),
  }),
  setActiveDateRange: PropTypes.func,
};

export default DailyPointSlider;
